import React from 'react';
// Components
import SetupDeals from 'components/common/SetupDeals/SetupDeals';

const SetupContentCreatorDeals: React.FC = () => {
  return <SetupDeals />;
};

export default SetupContentCreatorDeals;
